<template>
  <div class="tenant">
    <FixedHeader :showSearch="windowWidth >= 700">
      <b-button
        class="back-button"
        type="is-text"
        icon-left="arrow-left"
        size="is-medium"
        @click="goTo()"
      ></b-button>
      <a @click="goTo()">
        <img
          class="logo"
          alt="Pinwall logo"
          :src="
            require(`../assets/img/${
              darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
            }`)
          "
        />
      </a>
    </FixedHeader>
    <div class="content">
      <Add />
      <Edit v-if="selectedTenant" :item="selectedTenant" />
      <List
        @selectItem="selectItem"
        @deleteItem="deleteItem"
        :items="tenants"
      />
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FixedHeader from "../components/FixedHeader";
import Footer from "@/components/Footer";
import Add from "../components/tenant/Add";
import Edit from "../components/tenant/Edit";
import List from "../components/tenant/List";
import { goTo } from "../mixins/goTo.js";

export default {
  name: "Tenant",
  components: {
    FixedHeader,
    Add,
    Edit,
    List,
    Footer
  },
  data: () => {
    return {
      password: "",
      selectedTenant: null
    };
  },
  mixins: [goTo],
  computed: {
    ...mapGetters(["user", "tenants", "darkMode"])
  },
  methods: {
    ...mapActions(["changePassword", "loadTenants", "deleteTenant"]),
    selectItem(item) {
      this.selectedTenant = item;
    },
    deleteItem(item) {
      this.$buefy.dialog.confirm({
        message: "Do you want to delete this tenant?",
        onConfirm: () => {
          this.deleteTenant(item);
        }
      });
    }
  },
  created() {
    if (!this.user) {
      this.goTo();
    }

    if (this.user.email !== "pbabey10@gmail.com") {
      this.goTo();
    }
  },
  mounted() {
    this.loadTenants();
  }
};
</script>
